const settings = {
  baseURL: process.env.REACT_APP_BASE_URL,
  catalogBaseURL: process.env.REACT_APP_CATALOG_BASE_URL || "https://admin-catalog.bozor.taqsim.uz/api",
  clientBaseURL: process.env.REACT_APP_CLIENT_BASE_URL,
  requestTimeout: 60000 * 5,
  staleTime: 1000 * 60 * 2,
};

export default settings;
